<template>
<div>
    <draggable v-model="this.$store.state.search.set.search_history" group="people" item-key="id" handle=".handle.md_icon-btn" @end="endDraggable">
        <template #item="{element, index}">
            <div class="card" v-if="element.type == getType">
                <div class="link-ovl" v-on:click="clickSearchHistory(element)"></div>

                <div class="detail-wrap">
                    <div class="img-wrap">
                        <figure v-for="(brand_path,brand_path_index) in element.brand_path" v-bind:key="brand_path_index">
                            <img v-bind:src=" $store.state.const.AWS_S3_URL_HOST + brand_path" alt="">
                        </figure>
                    </div>
                    <div class="title">
                        <span v-for="(brand_history,brand_history_index) in element.brand_history" v-bind:key="brand_history_index">
                            <template v-if="brand_history_index == 0">{{brand_history}}</template>
                            <template v-else> / {{brand_history}}</template>
                        </span>
                    </div>
                </div>

                <div class="chevron"></div>

                <!--ovl-->
                <div class="edit-ovl">
                    <div class="handle md_icon-btn">
                        <div class="inner"><SvgIconSortHandle /></div>
                    </div>
                    <div class="icon-btn-wrap">
                        <button class="md_icon-btn" v-on:click="deleteActive = index">
                            <div class="inner"><SvgIconDelete /></div>
                        </button>
                    </div>
                    <div v-bind:class="[deleteActive === index ? '_deleteActive' : '', 'delete-ovl']">
                        <div class="inner">
                            <p>本当に削除しますか？</p>
                            <div class="button-wrap">
                                <button type="button" v-on:click="deleteCancelButton"><span>キャンセル</span></button>
                                <button type="button" v-on:click="deleteButton(index)"><span>削除する</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </draggable>
</div>
</template>


<script>
    //SvgIcon
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconSortHandle from '@/components/EndUser/svg/SvgIconSortHandle'
    import draggable from "vuedraggable";

    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'

    export default {
        data() {
            return {
                deleteActive: false,
            }
        },
        components: {
            //SvgIcon
            SvgIconDelete,
            SvgIconEdit,
            SvgIconSortHandle,
            draggable,
        },
        computed: {
            getType() {
                if (location.pathname == '/showroom-list') {
                    return 2;
                } else {
                    return 1;
                }
            },
        },
        methods: {
            clickSearchHistory (search_history) {
                // var formData = search_history;
                // var jsontext = JSON.stringify(formData)

                // var form = document.createElement('form');
                // form.action = '/brand-list';
                // form.method = 'POST';

                // var q = document.createElement('input');
                // q.value = jsontext;
                // q.name = 'form';
                // form.appendChild(q);

                // var csrf = document.createElement('input');
                // var token = $('[name="csrf-token"]').attr('content');
                // csrf.type = 'hidden';
                // csrf.name = '_token';
                // csrf.value = token;
                // form.appendChild(csrf);
                // document.body.appendChild(form);
                // form.submit();
                if (location.pathname == '/showroom-list') {
                    var url = '/showroom-list';
                } else {
                    var url = '/brand-list';
                }
                const form = reactive({
                    search_form: search_history,
                })
                Inertia.get(url, form, {
                    onSuccess: (page) => {
                        location.reload();
                    },
                })
            },
            deleteButton (index) {
                if (this.$store.state.search.set.user) { // ログイン
                    this.$store.state.search.set.search_history.splice(index, 1)

                    axios.post('/brand_search_history',{
                        form: this.$store.state.search.set.search_history
                    }).then(()=>{
                    })
                } else { // 非ログイン
                    this.$store.state.search.set.search_history.splice(index, 1)
                    localStorage.setItem('forms', JSON.stringify(this.$store.state.search.set.search_history));
                }
                this.deleteActive = '';
            },
            deleteCancelButton () {
                this.deleteActive = '';
            },
            endDraggable () {
                if (this.$store.state.search.set.user) { //ログイン
                    axios.post('/brand_search_history',{
                        form: this.$store.state.search.set.search_history
                    }).then(()=>{
                    })
                } else { // 非ログイン
                    localStorage.setItem('forms', JSON.stringify(this.$store.state.search.set.search_history));
                }
            }
        }
    }
</script>
